// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectDealerCriteria = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_SETTLEMENT_NO_REGISTRATION_DEALER
});

export const selectAllDealersCriteria = dealers => ({
    dealers,
    type: actions.SELECT_ALL_SETTLEMENT_NO_REGISTRATION_DEALERS
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.SELECT_ALL_SETTLEMENT_NO_REGISTRATION_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/action-creators/select-dealer.js